import constants from '@/config/constants.js'

export default {
  namespaced: true,

  state: () => {
    return {
      sortProperty: constants.SORT_PROPERTIES.PHOTO_NEWEST,
      sortOrderReversed: false,
    }
  },

  mutations: {
    RESET_SORTING (state) {
      state.sortProperty = constants.SORT_PROPERTIES.PHOTO_NEWEST
      state.sortOrderReversed = false
    },

    SET_SORT_PROPERTY (state, sortProperty) {
      state.sortProperty = sortProperty
    },

    SET_SORT_ORDER_REVERSED (state, sortOrderReversed) {
      state.sortOrderReversed = sortOrderReversed
    },

    FULL_RESET (state) {
      state.sortProperty = constants.SORT_PROPERTIES.PHOTO_NEWEST
      state.sortProperty = false
    },
  },
}
